import styled from 'styled-components';
import { useCallback } from 'react';
import { usePositionGroups } from '@paradigm/features/src/positions/contexts/position-groups';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import Checkbox from '@paradigm/design-system/src/components/Checkbox';
import { useTrackAction } from '@paradigm/features/src/analytics';

export default function GroupSelection() {
  const { toggleGroup, isGroupActive } = usePositionGroups();
  const trackAction = useTrackAction();

  const handleGroupByProduct = useCallback(() => {
    if (!isGroupActive('product'))
      trackAction('group positions', { groupBy: 'product' });
    toggleGroup('product');
  }, [isGroupActive, toggleGroup, trackAction]);

  const handleGroupByAccount = useCallback(() => {
    if (!isGroupActive('account_name'))
      trackAction('group positions', { groupBy: 'account' });
    toggleGroup('account_name');
  }, [isGroupActive, toggleGroup, trackAction]);

  const handleGroupByExpiry = useCallback(() => {
    if (!isGroupActive('expires_at'))
      trackAction('group positions', { groupBy: 'expiry' });
    toggleGroup('expires_at');
  }, [isGroupActive, toggleGroup, trackAction]);

  return (
    <Container>
      <span css="opacity: 0.7;">Group By</span>
      <Checkbox
        onCheck={handleGroupByProduct}
        isChecked={isGroupActive('product')}
        label="Product"
        dataTestId="positions-table-product-checkbox"
      />
      <Checkbox
        onCheck={handleGroupByAccount}
        isChecked={isGroupActive('account_name')}
        label="Account"
        dataTestId="positions-table-account-checkbox"
      />
      <Checkbox
        onCheck={handleGroupByExpiry}
        isChecked={isGroupActive('expires_at')}
        label="Expiry"
        dataTestId="positions-table-expiry-checkbox"
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  grid-area: grouping;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0 1rem;
  }
`;
